import styles from "./styles.module.scss";

function Slide1() {
    return (
        <>
            <section className={styles.container}>
                <div className={styles.picture}>
                    <img src="/images/carrousel/webdev.jpg" alt="digital" />
                </div>
                <div className={styles.info}>
                    <div className={styles.title}>Développement Web</div>
                    <div className={styles.title}>Renforcer </div>
                    <div className={styles.title}>la compétitivité</div>
                    <div className={styles.title}>De nos clients</div>
                    <div className={styles.sub_title}>Rapidité compétitivité agilité</div>
                    
                </div>
            </section>
        </>
    )
}

export default Slide1;